import PropTypes from 'prop-types';
import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import React from 'react';
import Document from '../../gant/components/mediasPages/Document';
import { useGetDocumentsQuery } from '../../../redux/api/cache';

export default function MessageDocuments(props) {
  const { data: documents = {}, isLoading } = useGetDocumentsQuery({ ann_seq: props.data.ann_seq, media: props.data.media_cd });

  return !isLoading ? (
    <Card
      expanded={documents?.data?.length > 0 || isLoading}
      key={'card document'}
    >
      <Header title="Documents"></Header>
      {!isLoading && (
        <Body>
          <Document
            media={props.data.media_cd}
            rowData={props.data}
            data={documents}
          />
        </Body>
      )}
    </Card>
  ) : (
    <LoadingCard title="Chargement Documents..." />
  );
}

MessageDocuments.propTypes = {
  data: PropTypes.shape({
    ann_seq: PropTypes.any,
    media_cd: PropTypes.any,
  }),
};
